

const Get_TKB = '/Calendar/Get_TKB' //日历
const login ="/Login/Login"
const Register ="/Login/Register"
const GetLOG ="/Calendar/Get_LOG"
const Upd_Pwd ="/Login/Upd_Pwd" //修改密码
const Get_Point ="/Points/Get_Point" //积分
const Get_User ="/User/Get_User" //获取当前登录者用户信息
const Upd_User ="/User/Upd_User" //更改当前登录者个人信息
const SaveCard ="/User/SaveCard" //保存信用卡信息
const Get_OrderInfo ="/OrderInfo/Get_OrderInfo" //获取去订单列表
const Get_Order_Byid ="/OrderInfo/Get_Order_Byid" //获取订单详情
const GET_INI_LIST ="/INI/GET_INI_LIST" //rideo下拉框接口
const Get_MDT_HOUSE_MONEY ="/ReserveCar/Get_MDT_HOUSE_MONEY" //（获取下单页的 3 6 9 24h 加一日 ）车辆名称 车辆ID  车辆图片
const Get_TKA_BY_CARD ="/ReserveCar/Get_TKA_BY_CARD" //（前回信用卡
const Add_TKA ="/ReserveCar/Add_TKA" //下单
const Get_Car ="/CarLine/Get_Car" //（获取车辆列表）
const Get_Car_BYID ="/CarLine/Get_Car_BYID" //（获取车辆详情）
const Get_Register_Code ="/Login/Get_Register_Code" //（获取注册验证码）
const Get_Upd_Code ="/Login/Get_Upd_Code" //（忘记密码注册验证码）
const Upd_TKA ="/ReserveCar/Upd_TKA" //获取支付状态并将TKADELFG变为0
const Get_TKA ="/ReserveCar/Get_TKA" //获取订单信息
const Get_CAR_TIME ="/ReserveCar/Get_Car_BYID" //获取可选时间段
export default {
	 //JSONIP: 'http://43.254.1.164:6072/',
	//JSONIP: 'http://localhost:49562/',
	JSONIP: 'https://booking-ws.poplus.jp/',
	Get_TKB,
	login,
	Register,
	GetLOG,
	Upd_Pwd,
	Get_Point,
	Get_User,
	Upd_User,
	SaveCard,
	Get_OrderInfo,
	Get_Order_Byid,
	GET_INI_LIST,
	Get_MDT_HOUSE_MONEY,
	Get_TKA_BY_CARD,
	Add_TKA,
	Get_Car,
	Get_Car_BYID,
	Get_Register_Code,
	Get_Upd_Code,
	Upd_TKA,
	Get_TKA,
	Get_CAR_TIME
}
